import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Reports_custom_ds_inventory_by_license_plate_reportService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async get($inParams: { projectId: number }): Promise<{ result?: { data?: { LP?: string, Location?: string, Warehouse?: string, Project?: string, Material?: string, Lot?: string, Total_Amount?: number, Packaging?: string, Gross_Weight?: number, Weight_Uom?: string, Vendor_Lot?: string, Expiration_Date?: string, Manufacture_Date?: string, Received_Date?: string, Material_Description?: string }[] } }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.projectId)) {
      $missingRequiredInParams.push('\'projectId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      projectId: number    }) {
        if(isNil($inParams.projectId)) {
          return true; 
        }
      return false;
    }
}
